export const cookieUtils = {
  getCookie(name: string): string | null {
    if (typeof document === 'undefined') return null
    const value = `; ${document.cookie}`
    const parts = value.split(`; ${name}=`)
    if (parts.length === 2) {
      return parts.pop()?.split(';').shift() || null
    }
    return null
  },

  setCookie(name: string, value: string, days: number = 7): void {
    if (typeof document === 'undefined') return

    const expires = new Date()
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000)

    const isDev = import.meta.env.DEV
    const domainPart = isDev ? '' : ';domain=.ngos.ly'

    const cookieString = `${name}=${value};expires=${expires.toUTCString()};path=/;SameSite=Lax${domainPart}`
    document.cookie = cookieString
  },

  deleteCookie(name: string): void {
    if (typeof document === 'undefined') return

    const isDev = import.meta.env.DEV
    const domainPart = isDev ? '' : ';domain=.ngos.ly'

    console.log(`Deleting cookie: ${name}`)
    console.log(`Environment: ${isDev ? 'development' : 'production'}`)

    // Delete cookie with same domain and path settings used when creating it
    const deleteString1 = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax${domainPart}`
    console.log(`Delete string 1: ${deleteString1}`)
    document.cookie = deleteString1

    // Also try deleting without domain (fallback for any cookies set without domain)
    const deleteString2 = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;SameSite=Lax`
    console.log(`Delete string 2: ${deleteString2}`)
    document.cookie = deleteString2

    // Additional attempts for edge cases
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    document.cookie = `${name}=;max-age=0;path=/`

    console.log(`Cookie ${name} deletion attempted`)
  },

  getJWTToken(): string | null {
    return this.getCookie('jwtTokenLocal') || this.getCookie('jwtToken')
  },

  setUserData(role: string | null, city: { id: number; documentId: string; name: string } | null): void {
    if (role && typeof role === 'string') {
      this.setCookie('userRole', role, 7)
    } else {
      this.deleteCookie('userRole')
    }

    if (city) {
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem('userCity', JSON.stringify(city))
        // Remove cookie if it exists to avoid confusion
        this.deleteCookie('userCity')
      } else {
        // Fallback for environments without localStorage
        this.setCookie('userCity', JSON.stringify(city), 7)
      }
    } else {
      if (typeof localStorage !== 'undefined') {
        localStorage.removeItem('userCity')
      }
      this.deleteCookie('userCity')
    }
  },

  getUserRole(): string | null {
    return this.getCookie('userRole')
  },

  getUserCity(): { id: number; documentId: string; name: string } | null {
    let cityData: string | null = null

    // Try localStorage first
    if (typeof localStorage !== 'undefined') {
      cityData = localStorage.getItem('userCity')
    }

    // Fallback to cookie if not in localStorage
    if (!cityData) {
      cityData = this.getCookie('userCity')

      // If found in cookie, migrate to localStorage for future
      if (cityData && typeof localStorage !== 'undefined') {
        localStorage.setItem('userCity', cityData)
      }
    }

    if (cityData) {
      try {
        return JSON.parse(cityData)
      } catch {
        return null
      }
    }
    return null
  },

  clearUserData(): void {
    this.deleteCookie('userRole')
    this.deleteCookie('userCity')
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem('userCity')
    }
  },

  clearAllAuthCookies(): void {
    // Debug: Log current cookies before clearing
    console.log('Clearing auth cookies. Current cookies:', document.cookie)
    console.log('JWT Token before clearing:', this.getJWTToken())

    // Clear all possible JWT token cookies
    this.deleteCookie('jwtTokenLocal')
    this.deleteCookie('jwtToken')
    this.clearUserData()

    // Debug: Log cookies after clearing
    console.log('Cookies after clearing:', document.cookie)
    console.log('JWT Token after clearing:', this.getJWTToken())
  },
}